import Vue from 'vue'
// 基础控件 id-41
export const BasicsControlList = [{
    name: '阀门横',
    controlId: 1,
    url: require("@/assets/editor-icon/fmh.png"),
    style: 'margin-top: 28px; width: 50px; height: 23px;'
  },
  {
    name: '阀门竖',
    controlId: 2,
    url: require("@/assets/editor-icon/fms.png"),
    style: 'margin-top: 17px; width: 36px; height: 36px;'
  },
  {
    name: '文本标签',
    controlId: 3,
    url: require("@/assets/editor-icon/wbbq.png"),
    style: 'margin-top: 21px; width: 35px; height: 32px;'
  },
  {
    name: '属性看板',
    controlId: 4,
    url: require("@/assets/editor-icon/sxkb.png"),
    style: 'margin-top: 19px; width: 34px; height: 34px;'
  },
  {
    name: 'X轴管道',
    controlId: 5,
    url: require("@/assets/editor-icon/xzgd.png"),
    style: 'margin-top: 33px; width: 42px; height: 20px;'
  },
  {
    name: 'Y轴管道',
    controlId: 6,
    url: require("@/assets/editor-icon/yzgd.png"),
    style: 'margin-top: 10px; width: 21px; height: 43px;'
  },
  {
    name: '仪表横',
    controlId: 7,
    url: require("@/assets/editor-icon/ybh.png"),
    style: 'margin-top: 15px; width: 40px; height: 38px;'
  },
  {
    name: '仪表竖',
    controlId: 8,
    url: require("@/assets/editor-icon/ybs.png"),
    style: 'margin-top: 13px; width: 38px; height: 40px;'
  },
  {
    name: '时间',
    controlId: 9,
    url: require("@/assets/editor-icon/sj.png"),
    style: 'margin-top: 19px; width: 35px; height: 34px;'
  },
  {
    name: '进度条',
    controlId: 10,
    url: require("@/assets/editor-icon/jdt.png"),
    style: "margin-top: 18px; width: 36px; height: 35px;"
  },
  {
    name: '报警灯',
    controlId: 11,
    url: require("@/assets/editor-icon/bjd.png"),
    style: 'margin-top: 15px; width: 37px; height: 38px'
  },
  {
    name: '指示灯',
    controlId: 12,
    url: require("@/assets/editor-icon/zsd.png"),
    style: "margin-top: 17px; width:  25px; height: 36px;"
  },
  {
    name: '直线横',
    controlId: 13,
    url: require("@/assets/editor-icon/zxh.png"),
    style: "margin-top: 33px; width:  43px; height: 10px; margin-bottom: 10px;"
  },
  {
    name: '直线竖',
    controlId: 14,
    url: require("@/assets/editor-icon/zxs.png"),
    style: "margin-top: 10px; width: 10px; height: 43px;"
  },
  {
    name: '矩形',
    controlId: 15,
    url: require("@/assets/editor-icon/jx.png"),
    style: "margin-top: 21px; width:  32px; height: 32px;"
  },
  {
    name: '圆形',
    controlId: 16,
    url: require("@/assets/editor-icon/yx.png"),
    style: "margin-top: 19px; width: 34px; height: 34px;"
  },
  {
    name: '动态面板',
    controlId: 17,
    url: require("@/assets/editor-icon/dtmb.png"),
    style: "margin-top: 19px; width: 33px; height: 34px;"
  },
  {
    name: '弹窗',
    controlId: 34,
    url: require("@/assets/editor-icon/dtmb.png"),
    style: "margin-top: 19px; width: 33px; height: 34px;"
  },
  {
    name: '时间选择器',
    controlId: 30,
    url: require("@/assets/editor-icon/sj.png"),
    style: 'margin-top: 19px; width: 35px; height: 34px;'
  },
  {
    name: '导航菜单',
    controlId: 38,
    url: require("@/assets/editor-icon/sj.png"),
    style: 'margin-top: 19px; width: 35px; height: 34px;'
  },
]

// 图形控件
export const chartsControlList = [{
    name: '基础环图-3D',
    controlId: 18,
    url: require("@/assets/editor-icon/jcht.png"),
    style: "margin-top: 21px; width: 32px; height: 32px;"
  },
  {
    name: '基础环图',
    controlId: 31,
    url: require("@/assets/editor-icon/jcht.png"),
    style: "margin-top: 21px; width: 32px; height: 32px;"
  },
  {
    name: '基础饼图',
    controlId: 19,
    url: require("@/assets/editor-icon/jcbt.png"),
    style: "margin-top: 19px; width: 34px; height: 34px;"
  },
  {
    name: '平滑曲线图',
    controlId: 20,
    url: require("@/assets/editor-icon/phqxt.png"),
    style: "margin-top: 21px; width:  61px; height: 32px;"
  },
  {
    name: '拐点折线图',
    controlId: 21,
    url: require("@/assets/editor-icon/gdzxt.png"),
    style: "margin-top: 18px; width: 35px; height: 35px;"
  },
  {
    name: '面积折线图',
    controlId: 22,
    url: require("@/assets/editor-icon/mjzxt.png"),
    style: "margin-top: 18px; width:  35px; height: 35px;"
  },
  // {
  //   name: 'AI预测图',
  //   controlId: 41,
  //   url: require("@/assets/editor-icon/mjzxt.png"),
  //   style: "margin-top: 18px; width:  35px; height: 35px;"
  // },
  {
    name: '横向柱状图',
    controlId: 23,
    url: require("@/assets/editor-icon/hxzzt.png"),
    style: "margin-top: 19px; width: 31px; height: 34px;"
  },
  {
    name: '纵向柱状图',
    controlId: 24,
    url: require("@/assets/editor-icon/zxzzt.png"),
    style: "margin-top: 22px; width: 34px; height: 31px;"
  },
  {
    name: '堆叠柱状图',
    controlId: 25,
    url: require("@/assets/editor-icon/ddzzt.png"),
    style: "margin-top: 22px; width: 34px; height: 31px;"
  },
  {
    name: '散点图',
    controlId: 26,
    url: require("@/assets/editor-icon/sdt.png"),
    style: "margin-top: 22px; width: 34px; height: 31px;"
  },
  {
    name: '雷达图',
    controlId: 27,
    url: require("@/assets/editor-icon/ldt.png"),
    style: "margin-top: 17px; width: 36px; height: 36px;"
  },
  {
    name: '仪表盘',
    controlId: 28,
    url: require("@/assets/editor-icon/ybp.png"),
    style: "margin-top: 13px; width: 38px; height: 40px;"
  },
  {
    name: '百分比仪表盘',
    controlId: 32,
    url: require("@/assets/editor-icon/ybp.png"),
    style: "margin-top: 13px; width: 38px; height: 40px;"
  },
  {
    name: '基础水球图',
    controlId: 33,
    url: require("@/assets/editor-icon/ybp.png"),
    style: "margin-top: 13px; width: 38px; height: 40px;"
  },
  {
    name: '等级环形图',
    controlId: 35,
    url: require("@/assets/editor-icon/ybp.png"),
    style: "margin-top: 13px; width: 38px; height: 40px;"
  },
  {
    name: '横向等级图',
    controlId: 37,
    url: require("@/assets/editor-icon/xzgd.png"),
    style: 'margin-top: 33px; width: 42px; height: 20px;'
  },
  {
    name: '列表',
    controlId: 29,
    url: require("@/assets/editor-icon/lb.png"),
    style: "margin-top: 22px; width: 32px; height: 31px;"
  },
  {
    name: '日历',
    controlId: 36,
    url: require("@/assets/editor-icon/sj.png"),
    style: 'margin-top: 19px; width: 35px; height: 34px;'
  },
  /*
  {
    name: '抄表',
    controlId: 39,
    url: require("@/assets/editor-icon/lb.png"),
    style: "margin-top: 22px; width: 32px; height: 31px;"
  },
   */
  {
    name: '设备地图-3d',
    controlId: 40,
    url: require("@/assets/editor-icon/lb.png"),
    style: "margin-top: 22px; width: 32px; height: 31px;"
  },
]

export const BasicsControlConfigList = [{
    x: 0, //定位x
    y: 0, //定位y
    width: 23, //宽
    height: 23, //高
    name: '阀门横', //控件名
    type: "image", //控件类型
    locked: false, //锁定
    controlId: 1, //控件id - 固定
    // url: require("@/assets/image/editor/Device/Verticalvalve.png"),https://iot.yonjie.com/fonts/indexEditorIcon/
    url: "Verticalvalve.png", //  控件图片名
    controlName: '阀门横', //控件名 - 可编辑
    DeviceId: null, //当前所关联的设备id
    DeviceName: '', //当前所关联的设备name
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    name: '阀门竖',
    type: "image",
    locked: false,
    controlId: 2,
    // url: require("@/assets/image/editor/Device/Horizontalvalve.png"),
    url: "Horizontalvalve.png",
    controlName: '阀门竖',
    DeviceId: null, //当前所关联的设备id
    DeviceName: '', //当前所关联的设备name
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 80,
    height: 29,
    name: '文本标签',
    type: "textSpan",
    locked: false,
    controlId: 3,
    companyId: null, //关联企业
    controlName: '文本标签',
    spanShowValue: false, //是否显示属性值
    textBold:false, //是否加粗
    fontSize: 14, //字体大小
    dataType:2, //数据类型 1:数据集 2:设备属性
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    datasetId: null, //当前所关联的数据集id
    fontColor: "#ffffff", //字体颜色
    bgColor: "#505050", //背景颜色
    opacity: 100, //透明度
    DeviceAttr: null, //当前所关联的设备属性
    AttrName: null, //关联属性名称
    ShowAttrName: false, //显示设备属性名称
    ShowAttrCode: null, //当前所关联显示属性
    ShowAttrKey: null, //当前所关联显示属性值
    interactiveList: [], //交互列表
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 80,
    height: 29,
    name: '属性看板',
    type: "attrSpan",
    companyId: null,
    locked: false,
    controlId: 4,
    controlName: '属性看板',
    spanShowValue: false, //是否显示属性值
    fontSize: 14, //字体大小
    fontColor: "#ffffff", //字体颜色
    bgColor: "#505050", //背景颜色
    opacity: 100, //透明度
    AttrList: [], //当前所关联的设备id
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 84,
    height: 8,
    name: 'X轴管道',
    type: "conduit",
    companyId: null,
    locked: false,
    // url: require("@/assets/image/editor/gray.png"),
    url: "gray.png",
    controlId: 5, //控件id
    direction: 0, //流动方向
    FarLeft: 0, //左端接头id
    NearRight: 0, //右端接头id
    controlName: 'X轴管道', //控件名称
    controlColorId: 1, //管道颜色id
    DeviceAttr: null, //关联设备属性
    compare: null, //比较类型
    compareVal: null, //比较值
    // imageGif: 'https://iot.yonjie.com/fonts/indexEditorIcon/gray_gif.gif'), //gif
    // imagePng: 'https://iot.yonjie.com/fonts/indexEditorIcon/gray_png.png') //png
    imageGif: "gray_gif.gif", //流动素材
    imagePng: "gray_png.png", //静态素材
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 8,
    height: 84,
    name: 'Y轴管道',
    type: "conduit",
    companyId: null,
    locked: false,
    controlId: 6,
    direction: 0,
    FarTop: 0,
    NearBottom: 0,
    // url: require("@/assets/image/editor/gray_top.png"),
    url: "gray_top.png",
    controlName: 'Y轴管道',
    controlColorId: 1,
    DeviceAttr: null,
    compare: null,
    compareVal: null,
    // imageGif: 'https://iot.yonjie.com/fonts/indexEditorIcon/gray_top_gif.gif'), //gif
    // imagePng: 'https://iot.yonjie.com/fonts/indexEditorIcon/gray_top_png.png') //png
    imageGif: "gray_top_gif.gif",
    imagePng: "gray_top_png.png",
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 36,
    height: 30,
    name: '仪表横',
    type: "image",
    locked: false,
    controlId: 7,
    // url: require("@/assets/image/editor/Device/Horizontalwatch.png"),
    url: "Horizontalwatch.png",
    controlName: '仪表横',
    DeviceId: null, //当前所关联的设备id
    DeviceName: '', //当前所关联的设备name
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 33,
    height: 35,
    name: '仪表竖',
    type: "image",
    locked: false,
    controlId: 8,
    // url: require("@/assets/image/editor/Device/Verticalwatch.png"),
    url: "Verticalwatch.png",
    controlName: '仪表竖',
    DeviceId: null, //当前所关联的设备id
    DeviceName: '', //当前所关联的设备name
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 183,
    height: 37,
    name: '时间',
    type: "time",
    locked: false,
    controlId: 9,
    controlName: '时间',
    dateColor: "#ffffff",
    timeColor: "#ffffff",
    dateSize: 16, //日期字体大小
    timeSize: 35, //时间字体大小
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 350,
    height: 56,
    name: '进度条',
    type: "progress",
    companyId: null,
    locked: false,
    controlId: 10,
    controlName: '进度条',
    barWidth: 344, //进度条长度
    barHeight: 12,
    bgColor: "rgba(61,157,255,0.3)",
    fgColor: '#3d9dff',
    borderColor: "transparent",
    borderWidth: 0,
    borderRadius: 0,
    lineColor: "transparent",
    lineWidth: 1,
    lineNum: 5,
    textShow: true,
    titleColor: "#ffffff",
    titleSize: 24,
    numColor: "#30A0FF",
    numSize: 24,
    opacity: 100,
    colorAttr: null,
    colorList: [],
    progressAttr: null,
    rotation:0,     //旋转角度

  },
  {
    x: 0,
    y: 0,
    width: 28,
    height: 34.5,
    name: '报警灯',
    // url: require("@/assets/editor-icon/yzbj.png"),
    url: "yzbj.png",
    type: "image",
    locked: false,
    controlId: 11,
    companyId: null,
    controlName: '报警灯',
    DeviceId: null, //当前所关联的设备id
    DeviceName: '', //当前所关联的设备name
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    name: '指示灯',
    // url: require("@/assets/editor-icon/sbyx.png"),
    url: "zsd1.png",
    url1: "zsd8.png",
    url2: "zsd1.png",
    type: "image",
    controlId: 12,
    locked: false,
    companyId: null,
    controlName: '指示灯',
    DeviceAttr: null,
    lampUrl1: null,
    lampUrl2: null,
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 60,
    height: 5,
    name: '直线横',
    type: "hline",
    locked: false,
    controlId: 13,
    controlName: '直线横',
    lineColor: "#ffffff",
    lineWidth: 1,
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 5,
    height: 60,
    name: '直线竖',
    locked: false,
    controlId: 14,
    type: "vline",
    controlName: '直线竖',
    lineColor: "#ffffff",
    lineWidth: 1,
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    name: '矩形',
    type: "rectangle",
    locked: false,
    controlId: 15,
    companyId: null,
    controlName: '矩形',
    radius: 0,
    borderColor: "#ffffff",
    borderRadius: 0,
    borderWidth: 1,
    bgColor: "transparent",
    opacity: 100,
    colorAttr: null, //颜色关联属性
    colorList: [], //颜色配置数组
    DeviceAttrBlock: [], //设备属性面板
    interactiveList: [],
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    name: '圆形',
    radius: "50%",
    type: "circular",
    locked: false,
    controlId: 16,
    companyId: null,
    controlName: '圆形',
    borderColor: "#ffffff",
    borderWidth: 1,
    bgColor: "transparent",
    opacity: 100,
    colorAttr: null, //颜色关联属性
    colorList: [], //颜色配置数组
    DeviceAttrBlock: [], //设备属性面板
    interactiveList: [],
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 300,
    height: 220,
    name: '动态面板',
    type: "panel",
    locked: false,
    controlId: 17,
    controlName: '动态面板',
    borderColor: "#ffffff",
    borderWidth: 1,
    borderRadius: 0,
    blockList: [{
      value: 1,
      name: "state1"
    }],
    blockContentList: [{
      id: 1,
      drags: []
    }],
    listShow: false,
    activeBlock: 1,
    activeBlockName: "state1",
    bgColor: "#151515",
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 300,
    height: 220,
    name: '弹窗',
    type: "proup",
    locked: false,
    controlId: 34,
    controlName: '弹窗',
    borderColor: "#ffffff",
    borderWidth: 1,
    borderRadius: 0,
    parentId:null,
    bgColor: "#151515",
    children:[],
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 358,
    height: 42,
    name: '时间选择器',
    controlName: '时间选择器',
    type: "chartTime",
    locked: false,
    controlId: 30,
    borderColor: "#ffffff",
    borderWidth: 1,
    borderRadius: 0,
    dateType: 2, // 当前激活状态
    timeVal: null, //当前选中的时间值
    fontColor: "#333", // 字体颜色
    bgColor: "#ffffff", //背景颜色
    fontSize: 14, //字体大小
    activedBgColor: "#5087e4", // 激活背景颜色
    activedFontColor: "#ffffff", // 激活字体颜色
    rate: 1, // 刷新频率
    oldData: false, // 上期数据
    chartsList: [], // 关联图表
    textList:[],    // 关联标签
    rotation:0,     //旋转角度
  },
  {
    x: 0,
    y: 0,
    width: 200,
    height: 600,
    vertical:true,
    name: '导航菜单',
    type: "navmenu",
    locked: false,
    controlId: 38,
    controlName: '导航菜单',
    bgColor: "#ffffff",
    fontSize:14,
    fontColor: "#303133",
    activedFontColor: "#5087e4",
    activedBgColor:"#f0f0f0",
    borderColor: "#ffffff",
    borderWidth: 1,
    borderRadius: 0,
    rotation:0,     //旋转角度
    opacity: 100,
  },
]
// 图表控件配置
export const ChartsControlConfigList = [{
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '基础环图-3D',
    type: "graph",
    controlId: 18,
    locked: false,
    companyId: null,
    controlName: '基础环图-3D',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: 1, //时间粒度
    granularityUint: 1, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    legend: true, //图例
    legendTextShow: true, //是否显示图例文字
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 380,
    height: 320,
    name: '基础环图',
    type: "graph",
    locked: false,
    controlId: 31,
    companyId: null,
    options: {
      legend: {
        top: 'center',
        right: '10',
        icon: "circle",
        orient: "vertical",
        textStyle: {
          color: "#AFC0D0",
          overflow: "truncate"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(params) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background-color:${params.color};border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#AFC0D0;font-weight:400;">${params.name}</span>
              </p>
              `
          let text =
            `<span style="color:${params.color};">${params.data.value}${params.data.unit||''},  ${params.data.realityData||params.data.realityData==0?params.data.realityData:params.data.value}%</span>`
          html += text
          return html
        },
      },
      series: [{
        name: 'Access From',
        type: 'pie',
        top: 0,
        bottom: 0,
        left: 0,
        right: 100,
        radius: ['50%', '80%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          formatter: "{d}%"
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 24,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [{
            value: 1042,
            name: '压力'
          },
          {
            value: 735,
            name: '电量'
          },
          {
            value: 580,
            name: '流量'
          },
        ]
      }]
    },
    controlName: '基础环图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 380,
    height: 320,
    name: '基础饼图',
    type: "graph",
    locked: false,
    controlId: 19,
    companyId: null,
    options: {
      // graphic: {
      //   elements: [
      //     {
      //         type: 'image',
      //         style: {
      //             image: 'https://iot.yonjie.com/assets/img/pie-bg.png',
      //             width:218,
      //             height:218,
      //         },
      //         left: '16%',
      //         top: '32.2%',
      //     },
      //   ],
      // },
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(params) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background-color:${params.color};border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#AFC0D0;font-weight:400;">${params.name}</span>
              </p>
              `
          let text =
            `<span style="color:${params.color};">${params.data.value}${params.data.unit||''},  ${params.data.realityData||params.data.realityData==0?params.data.realityData:params.data.value}%</span>`
          html += text
          return html
        },
      },
      legend: {
        top: 0,
        show: true,
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        icon: "circle",
        textStyle: {
          color: "#AFC0D0"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      series: [{
        name: 'Access From',
        type: 'pie',
        radius: '40%',
        center: ['50%', '50%'],
        label: {
          show: false
        },
        data: [{
          value: 1103,
          name: '烟感预警'
        }, {
          value: 2623,
          name: '视频预警'
        }, ],
        emphasis: {
          scaleSize: 5,
          itemStyle: {
            shadowBlur: 30,
            shadowOffsetX: 0,
            borderWidth: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
      }]
    },
    controlName: '基础饼图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },

  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '平滑曲线图',
    type: "graph",
    locked: false,
    controlId: 20,
    companyId: null,
    options: {
      xAxis: {
        type: "category",
        data: ['1月', '2月', '3月', '4月', '5月', '6月'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        }
      },
      legend: {
        icon: "circle",
        show: false,
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        // data: ['重度报警', '中度报警', '轻度报警'],
        textStyle: {
          color: "#AFC0D0"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(data) {
          let html = `
          <p>
            <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
            <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
          </p>
          `
          for (let item of data) {
            let text = `
            <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
              <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
            </p>`
            html += text
          }
          return html
        },
      },
      yAxis: {
        type: "value",
        // max: 250,
        // min: 0,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      series: [{
        data: [150, 200, 224, 218, 235, 147, 220],
        type: "line",
        smooth: true,
        name: "报警总数",
        symbolSize: 0,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [{
              offset: 1,
              color: "#4FACFE" // 0% 处的颜色
            }, {
              offset: 0,
              color: '#00F2FE' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          },
        },
        lineStyle: { // 阴影部分
          width: 4,
          shadowOffsetX: 5, // 折线的X偏移
          shadowOffsetY: 5, // 折线的Y偏移
          shadowBlur: 3, // 折线模糊
          shadowColor: "rgba(15, 15, 15, 1)", //折线颜色
        },
      }, ],
    },
    controlName: '平滑曲线图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: false, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '拐点折线图',
    type: "graph",
    locked: false,
    controlId: 21,
    companyId: null,
    options: {
      xAxis: {
        type: "category",
        data: ['1月', '2月', '3月', '4月', '5月', '6月'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
      },
      legend: {
        icon: "circle",
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        show: false,
        // data: ['重度报警', '中度报警', '轻度报警'],
        textStyle: {
          color: "#AFC0D0"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(data) {
          let html = `
          <p>
            <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
            <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
          </p>
          `
          for (let item of data) {
            let text = `
            <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
              <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
            </p>`
            html += text
          }
          return html
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      series: [{
        data: [150, 230, 224, 218, 135, 147],
        type: 'line',
        symbol: "circle",
        name: "报警总数",
        symbolSize: 7.5,
        itemStyle: {
          // color: '#5cfbff',
          emphasis: { // 鼠标经过时：
            // shadowColor: '#5cfbff',
            symbolSize: 9.5,
            shadowBlur: 10
          }
        },
      }]
    },
    controlName: '拐点折线图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: false, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '面积曲线图',
    type: "graph",
    locked: false,
    controlId: 22,
    companyId: null,
    options: {
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(data) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
              </p>
              `
          for (let item of data) {
            let text = `
                <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                  <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
                </p>`
            html += text
          }
          return html
        },
      },
      legend: {
        icon: "circle",
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        show: true,
        // data: ['重度报警', '中度报警', '轻度报警'],
        textStyle: {
          color: "#AFC0D0"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['1月', '2月', '3月', '4月', '5月', '6月'],
        boundaryGap: false,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
      },
      yAxis: {
        type: 'value',
        // max: 250,
        // min: 0,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      series: [{
          name: '轻度报警',
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            emphasis: { // 鼠标经过时：
              shadowColor: '#008AFF',
              shadowBlur: 10
            }
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(14, 87, 134, .5)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(14, 87, 134, .4)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(14, 87, 134, .3)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(14, 87, 134, .2)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(14, 87, 134, .1)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
          emphasis: {
            focus: 'series'
          },
          data: [23, 32, 42, 20, 11, 50]
        },
        {
          name: '中度报警',
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            emphasis: { // 鼠标经过时：
              shadowColor: '#00FFFF',
              shadowBlur: 10
            }
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(0,255,255, .5)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(0,255,255, .4)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(0,255,255, .3)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(0,255,255, .2)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(0,255,255, .1)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
          emphasis: {
            focus: 'series'
          },
          data: [132, 112, 142, 110, 131, 100]
        },
        {
          name: '重度报警',
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            emphasis: { // 鼠标经过时：
              shadowColor: '#F5B65C',
              shadowBlur: 10
            }
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(245,182,92, .5)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(245,182,92, .4)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(245,182,92, .3)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(245,182,92, .2)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(245,182,92, .1)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
          emphasis: {
            focus: 'series'
          },
          data: [152, 162, 192, 140, 161, 140]
        }
      ]
    },
    controlName: '面积曲线图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 640,
    height: 320,
    name: 'AI预测图',
    type: "graph",
    locked: false,
    controlId: 41,
    companyId: null,
    options: {
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(data) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
              </p>
              `
          for (let item of data) {
            let text = `
                <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                  <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
                </p>`
            html += text
          }
          return html
        },
      },
      legend: {
        // icon: "circle",
        // width: "90%",
        // height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        show: true,
        top:"10",
        data: ['储气量', '能耗', '入口温度', '出口温度'],
        textStyle: {
          color: "#AFC0D0"
        },
        itemStyle: {
          color: "inherit"
        },
        lineStyle: {
          opacity: 0
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      yAxis: [
        {
          type: 'value',
          name: '储气量',
          position: 'right',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#5070dd"
            }
          },
          axisLabel: {
            formatter: '{value} ml'
          }
        },
        {
          type: 'value',
          name: '能耗',
          position: 'right',
          alignTicks: true,
          offset: 80,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#b6d634'
            }
          },
          axisLabel: {
            formatter: '{value} ml'
          }
        },
        {
          type: 'value',
          name: '温度',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#505372'
            }
          },
          axisLabel: {
            formatter: '{value} °C'
          }
        }
      ],
      series: [
        {
          name: '储气量',
          type: 'bar',
          data: [
            2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
          ]
        },
        {
          name: '能耗',
          type: 'bar',
          yAxisIndex: 1,
          data: [
            2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
          ]
        },
        {
          name: '出口温度',
          type: 'line',
          yAxisIndex: 2,
          data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
        },
        {
          name: '入口温度',
          type: 'line',
          yAxisIndex: 2,
          data: [3.0, 3.2, 4.3, 5.5, 7.3, 9.2, 21.3, 25.4, 25.0, 18.5, 14.0, 18.2]
        }
      ]
    },
    controlName: 'AI预测图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 248,
    name: '横向柱状图',
    type: "ranking",
    locked: false,
    controlId: 23,
    companyId: null,
    controlName: '横向柱状图',
    borderWidth: 0,
    borderRadius: 0,
    fontSize: 14,
    barColor: "#6defdd",
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },

  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '纵向柱状图',
    type: "graph",
    locked: false,
    controlId: 24,
    companyId: null,
    options: {
      color: ['#FD6D77', '#D1994A', '#32DADA'],
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        formatter: function(data) {
          let html = `
                <p>
                  <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                  <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
                </p>
                `
          for (let item of data) {
            let text = `
                  <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                    <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
                  </p>`
            html += text
          }
          return html
        },
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(14, 87, 134, .6)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(14, 87, 134, .5)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(14, 87, 134, .4)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(14, 87, 134, .3)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(14, 87, 134, .2)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
        }
      },
      legend: {
        show: true,
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        textStyle: {
          color: "#AFC0D0"
        }
      },
      // toolbox: {
      //   show: true,
      //   orient: 'vertical',
      //   left: 'right',
      //   top: 'center',
      //   feature: {
      //     mark: {
      //       show: true
      //     },
      //     dataView: {
      //       show: true,
      //       readOnly: false
      //     },
      //     magicType: {
      //       show: true,
      //       type: ['line', 'bar', 'stack']
      //     },
      //     restore: {
      //       show: true
      //     },
      //     saveAsImage: {
      //       show: true
      //     }
      //   }
      // },
      xAxis: {
        type: 'category',
        axisTick: {
          show: false
        },
        data: ['重庆', '成都', '上海', '南京', '郑州'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      series: [{
          name: '重度报警',
          type: 'bar',
          label: {
            show: false,
          },
          xAxisIndex: 0,
          emphasis: {
            focus: 'series'
          },
          data: [30, 32, 31, 34, 30]
        },
        {
          name: '中度报警',
          type: 'bar',
          barGap: .5,
          label: {
            show: false,
          },
          xAxisIndex: 0,
          emphasis: {
            focus: 'series'
          },
          data: [20, 12, 11, 24, 29]
        },
        {
          name: '轻度报警',
          type: 'bar',
          barGap: .5,
          barMaxWidth: 12.5,
          barMinWidth: 2,
          label: {
            show: false,
          },
          xAxisIndex: 0,
          emphasis: {
            focus: 'series'
          },
          data: [15, 22, 20, 14, 19]
        }
      ]
    },
    controlName: '纵向柱状图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '堆叠柱状图',
    type: "graph",
    locked: false,
    controlId: 25,
    companyId: null,
    options: {
      color: ['#32DADA', '#D1994A', '#FD6D77'],
      legend: {
        show: true,
        width: "90%",
        height: "40px",
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: "#AFC0D0",
        pageTextStyle: {
          color: "#AFC0D0"
        },
        textStyle: {
          color: "#AFC0D0"
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        formatter: function(data) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
              </p>
              `
          for (let item of data) {
            let text = `
                <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                  <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data}</span>
                </p>`
            html += text
          }
          return html
        },
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(14, 87, 134, .6)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(14, 87, 134, .5)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(14, 87, 134, .4)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(14, 87, 134, .3)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(14, 87, 134, .2)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          },
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['重庆', '成都', '上海', '南京', '郑州'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      series: [{
          name: '轻度报警',
          type: 'bar',
          stack: 'Ad',
          itemStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [20, 12, 11, 13, 6, 20, 10]
        },
        {
          name: '中度报警',
          type: 'bar',
          stack: 'Ad',
          itemStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [20, 22, 11, 23, 11, 10, 13]
        },
        {
          name: '重度报警',
          type: 'bar',
          stack: 'Ad',
          barMaxWidth: 12.5,
          barMinWidth: 2,
          itemStyle: {},
          emphasis: {
            focus: 'series'
          },
          data: [10, 23, 21, 14, 10, 30, 10]
        },
      ]
    },
    controlName: '堆叠柱状图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '散点图',
    type: "graph",
    locked: false,
    controlId: 26,
    companyId: null,
    options: {
      xAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisTick: {
          show: false
        },
        boundaryGap: ['5%', '5%'],
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
          // formatter: (time) => {
          //   let M = new Date(time).getMonth() + 1
          //   return M + '月'
          // }
        },
        splitLine: {
          show: false,
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#435a6a',
            width: 1,
          }
        },
        axisLabel: {
          color: "#AFC0D0",
          fontSize: 12,
        },
        splitLine: {
          lineStyle: {
            color: '#2e353c',
            type: "dashed"
          }
        }
      },
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        formatter: function(data) {
          let html = `
          <p>
            <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
            <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data.value[0]}</span>
          </p>
          <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">
            <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${data.data[1]}</span>
          </p>
          `
          return html
        },
      },
      series: [{
        symbolSize: 18,
        symbol: 'image://' + require('@/../static/indexEditorIcon/sandian.png'),
        name: '报警总数',
        data: [
          [3, 28.04],
          [4, 22.23],
          [2, 26.95],
          [6, 37.83],
          [1, 27.58],
          [8, 48.96],
          [4, 43.81],
          [1, 63.33],
          [4, 54.33],
          [2, 47.21],
          [2, 76.66],
          [6, 57.23],
          [1, 61.24],
          [1, 68.04],
        ],
        type: 'scatter',
        emphasis: {
          scale: 1.2
        },
      }]
    },
    controlName: '散点图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    MinY:null,  //Y轴最小值
    MaxY:null,  //Y轴最大值
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: false, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }, {
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    scaleX: 10,
    scaleY: 5,
    dataNum: 10
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '雷达图',
    type: "graph",
    locked: false,
    controlId: 27,
    companyId: null,
    options: {
      radar: {
        indicator: [{
            text: '工程建设',
            max: 10
          },
          {
            text: '政府采购',
            max: 10
          },
          {
            text: '水利交易',
            max: 10
          },
          {
            text: '其他',
            max: 10
          },
          {
            text: '产权交易',
            max: 10
          }
        ],
        radius: '50%',
        startAngle: 90,
        splitNumber: 5,
        shape: 'circle',
        center: ['50%', '55%'],
        name: {
          rich: {
            a: {
              fontSize: '14',
              color: '#ffffff',
              lineHeight: '20'
            },
            b: {
              fontSize: '16',
              color: '#0FDADA',
              align: 'center',
              lineHeight: '20'
            }
          },
          formatter: (a, b) => {
            return `{a|${a}}\n{b|8%}`;
          }
        },
        splitArea: {
          areaStyle: {
            color: [
              'rgba(5, 129, 255, 0.5)', 'rgba(5, 129, 255, 0.4)', 'rgba(5, 129, 255, 0.3)',
              'rgba(5, 129, 255, 0.2)', 'rgba(5, 129, 255, 0.1)'
            ],
            shadowBlur: 0,
          }
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(211, 253, 250, 0.5)',
            type: 'dashed'
          }
        },
        splitLine: {
          lineStyle: {
            width: 0
          }
        }
      },
      series: {
        type: 'radar',
        emphasis: {
          lineStyle: {
            width: 4
          }
        },
        data: [{
          value: [8, 4, 5, 7, 9],
          symbol: "none",
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 2,
              x2: 1,
              y2: 0,
              colorStops: [{
                offset: 1,
                color: "rgba(121, 197, 255, .9)" // 0% 处的颜色
              }, {
                offset: .8,
                color: 'rgba(121, 197, 255, .6)' // 100% 处的颜色
              }, {
                offset: .6,
                color: 'rgba(121, 197, 255, .3)' // 100% 处的颜色
              }, {
                offset: .4,
                color: 'rgba(5, 129, 255, .3)' // 100% 处的颜色
              }, {
                offset: .2,
                color: 'rgba(5, 129, 255, .6)' // 100% 处的颜色
              }, {
                offset: 0,
                color: 'rgba(5, 129, 255, .9)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
          }
        }]
      }
    },
    controlName: '雷达图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
        attrKey: null,
        type: 1,
        min: 0,
        max: 1
      },
      {
        attrKey: null,
        type: 1,
        min: 0,
        max: 1
      },
      {
        attrKey: null,
        type: 1,
        min: 0,
        max: 1
      },
      {
        attrKey: null,
        type: 1,
        min: 0,
        max: 1
      },
      {
        attrKey: null,
        type: 1,
        min: 0,
        max: 1
      }
    ]
  },
  {
    x: 0,
    y: 0,
    width: 440,
    height: 320,
    name: '仪表盘',
    type: "graph",
    locked: false,
    controlId: 28,
    companyId: null,
    options: {
      graphic: [{
        type: "image",
        left: "center",
        top: "center",
        z: -10,
        bounding: "raw",
        scale: [1, 1], //缩放
        style: {
          // 背景图
          // image:require("@/assets/editor-icon/gauge-bg.png"),
          width: '50%',
          height: '50%',
          opacity: 1,
        },
      }],
      series: [{
        type: 'gauge',
        splitNumber: 20,
        max: 100,
        min: 0,
        center: ['50%', '55%'],
        axisLine: {
          lineStyle: {
            width: -0,
            color: [
              [0.1, '#bd4449'],
              [0.3, '#b09b65'],
              [0.7, '#0fdada'],
              [0.9, '#b09b65'],
              [1, '#bd4449']
            ]
          }
        },
        pointer: {
          icon: "image://" + require('@/../static/indexEditorIcon/blue.png'),
          width: 11,
        },
        axisTick: {
          length: 10,
          lineStyle: {
            color: 'auto',
            width: 1
          }
        },
        splitLine: {
          length: 15,
          lineStyle: {
            color: 'auto',
            width: 1.5
          }
        },
        axisLabel: {
          color: 'auto',
          distance: -40,
          fontSize: 16,
          formatter: function(value) { //只显示开始结束值
            let i = value / 100
            if (i == Infinity || i == 0 || i == 0.25 || i == 0.5 || i == 0.75 || i == 1) {
              return value
            } else {
              return ''
            }
          }
        },
        detail: {
          valueAnimation: true,
          formatter: '{value}',
          color: 'auto',
          fontSize: 24,
          offsetCenter: [0, "45%"],
          fontFamily: "YSBTH"
        },
        data: [{
          value: 80.0,
          name: "AQI",
          title: {
            color: "#ffffff",
            fontSize: 24,
            fontFamily: "YSBTH"
          }
        }]
      }]
    },
    controlName: '仪表盘',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: 1, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    percentage: false, //百分比
    maximum: false, //最值
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    // colorList:[
    //   {color:"#0fdada",compare:null,value:null},
    //   {color:"#b09b65",compare:null,value:null},
    //   {color:"#bd4449",compare:null,value:null},
    // ]
    max: 100,
    min: 0,
    gaugeMax: 70,
    gaugeMax2: 90,
    gaugeMin: 30,
    gaugeMin2: 10,
  }, {
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    name: '百分比仪表盘',
    type: "graph",
    locked: false,
    controlId: 32,
    companyId: null,
    options: {
      graphic: [{
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "42%",
          style: {
            text: `78.8%`,
            textAlign: "center",
            fill: "#ffffff", //文字的颜色
            fontSize: 13,
            fontWeight: "bold",
            lineHeight: 30,
          },
        },
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "55%",
          style: {
            text: `原件匹配度`,
            textAlign: "center",
            fill: "#ffffff", //文字的颜色
            fontSize: 14,
            lineHeight: 20,
          },
        },
      ],
      // tooltip: {
      //   trigger: 'item',
      //   backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
      //   borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
      //   axisPointer: {
      //     type: "line"
      //   },
      //   formatter: function(params) {
      //     let html = `
      //         <p>
      //           <span style="display:inline-block;width: 4px;height: 4px;background-color:${params.color};border-radius: 50%;position:relative; top:-2px;"></span>
      //           <span style="font-size:12px;color:#AFC0D0;font-weight:400;">${params.name}</span>
      //         </p>
      //         `
      //     let text =
      //       `<span style="color:${params.color};">${params.data.value}${params.data.unit||''},  ${params.data.realityData||params.data.realityData==0?params.data.realityData:params.data.value}%</span>`
      //     html += text
      //     return html
      //   },
      // },
      series: [{
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          min: 0, // min和max倒过来
          max: 360,
          radius: "75%",
          splitNumber: 7,
          clockwise: true, // 设置数据逆时针增长
          itemStyle: {
            color: "#eee", // 用于替代背景色的颜色
            borderColor: "#eee", // 用跟上面一样的颜色遮住露出的背景色
          },
          progress: {
            show: false
          },
          pointer: {
            show: false // 隐藏指针
          },
          axisLine: {
            roundCap: false, // 只适用于平角
            lineStyle: {
              width: 20,
              color: [] // 渐变色作为轴的背景色
            }
          },
          axisTick: {
            distance: -20,
            length: 20,
            lineStyle: {
              color: '#100c2a',
              width: 4,
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          title: {
            show: false
          },
          detail: {
            show: false
          }
        },
        {
          type: 'gauge',
          startAngle: 0,
          endAngle: 360,
          radius: '54%',
          axisLine: {
            lineStyle: {
              width: 1,
              shadowColor: '#138192',
              shadowBlur: 10,
              color: [
                [1, '#138192'],
              ],
              opacity: 1
            }
          },

          pointer: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false
          },
          detail: {
            show: false
          },
        },
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          radius: '82%',
          axisLine: {
            lineStyle: {
              width: 3,
              shadowColor: '#00fcfc',
              shadowBlur: 15,
              color: [
                [1, '#00fcfc'],
              ]
            }
          },

          pointer: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false
          },
          detail: {
            show: false
          },
        }
      ]
    },
    controlName: '百分比仪表盘',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    name: '基础水球图',
    type: "graph",
    locked: false,
    controlId: 33,
    companyId: null,
    options: {
      // graphic: {
      // 	elements: [{
      // 		type: 'image',
      // 		z: 3,
      // 		style: {
      // 			image: null,
      // 			width: 200,
      // 			height: 200
      // 		},
      // 		left: -1,
      // 		top: 'center',
      // 	}]
      // },
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(0,0,0,0.8)', // 提示框浮层的背景颜色
        borderColor: 'rgba(0,0,0,0.8)', // 提示框浮层的边框颜色。
        axisPointer: {
          type: "line"
        },
        formatter: function(params) {
          let html = `
              <p>
                <span style="display:inline-block;width: 4px;height: 4px;background-color:${params.data.color};border-radius: 50%;position:relative; top:-2px;"></span>
                <span style="font-size:12px;color:#AFC0D0;font-weight:400;">${params.name}</span>
              </p>
              `
          let text =
            `<span style="color:${params.data.color};">${params.data.realityData}${params.data.unit||''}</span>`
          html += text
          return html
        },
      },
      series: [{
      	type: 'liquidFill',
      	z: 6,
      	center: ['50%', '50%'],
      	radius: '60%',
      	data: [{
      		value: 0.48,
      		realityData: 0.48,
          color:"#0bbadb",
          name:"温度",
      		direction: 'right',
      		itemStyle: {
      			opacity: 1,
      			color: {
      				type: 'linear',
      				x: 0,
      				y: 0,
      				x2: 0,
      				y2: 1,
      				colorStops: [{
      					offset: 1,
      					color: 'rgba(11, 186, 219, .1)',
      				}, {
      					offset: 0.5,
      					color: 'rgba(11, 186, 219, .5)',
      				}, {
      					offset: 0,
      					color: 'rgba(11, 186, 219, 1)',
      				}],
      				globalCoord: true
      			},
      		}
      	},{
      		value: 0.48,
      		realityData: 0.48,
          color:"#0bbadb",
          name:"温度",
      		direction: 'left',
      		itemStyle: {
      			opacity: 1,
      			color: {
      				type: 'linear',
      				x: 0,
      				y: 0,
      				x2: 0,
      				y2: 1,
      				colorStops: [{
      					offset: 1,
      					color: 'rgba(11, 186, 219, .1)',
      				}, {
      					offset: 0.5,
      					color: 'rgba(11, 186, 219, .3)',
      				}, {
      					offset: 0,
      					color: 'rgba(11, 186, 219, .3)',
      				}],
      				globalCoord: true
      			},
      		}
      	}],
      	backgroundStyle: {
      		borderWidth: 2,
      		color: 'transparent',
      		borderColor: 'rgba(11, 186, 219, 1)',
      		shadowColor: 'rgba(11, 186, 219, 1)',
      		shadowBlur: 13,
      	},
      	label: {
      		normal: {
      			formatter: '',
      		}
      	},
      	outline: {
      		show: true,
      		itemStyle: {
      			borderWidth: 2.5,
      			borderColor: 'rgba(11, 186, 219, 1)',
      			shadowColor: 'rgba(11, 186, 219, 1)',
      			shadowBlur: 13,
      		},
      		borderDistance: 0,
      	}
      }]
    },
    controlName: '基础水球图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    min:0,
    max:1,
    gaugeMin:0.2,
    gaugeMin2:0.1,
    gaugeMax:0.8,
    gaugeMax2:0.9,
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 300,
    height: 300,
    name: '等级环形图',
    type: "graph",
    locked: false,
    controlId: 35,
    companyId: null,
    options: {
  series: [
    {
      type: 'gauge',
      startAngle: 200,
      radius:"90%",
      endAngle: -20,
      splitNumber:100,
      axisLine: {
        lineStyle: {
          width: 30,
          color: [
            [0.25, '#f95b3b'],
            [0.5, '#ff9c35'],
            [0.75, '#4cec75'],
            [1, '#0d88ca']
          ]
        }
      },
      pointer: {
        length: "90%",
        itemStyle: {
          color: 'inherit'
        }
      },
      axisTick: {
        show:false
      },
      splitLine: {
        show:false,
      },
      axisLabel: {
        distance: -8,
        color:"#ffffff",
        fontSize:12,
        formatter: function (value) {
            if (value === 10) {
                return '差';
            } else if (value === 40) {
                return '中';
            } else if (value === 60) {
                return '良';
            } else if (value === 90) {
                return '优';
            }
            return '';
        }
      },
      title:{
        offsetCenter:[0 , "36%"],
        fontSize:"14",
        color:"inherit"
      },
      detail: {
        offsetCenter:[0,"20%"],
        valueAnimation: true,
        fontSize:16,
        formatter: function (value) {
            if (value <=25) {
                return '差';
            } else if (value <=50) {
                return '中';
            } else if (value <=75) {
                return '良';
            } else if (value > 75) {
                return '优';
            }
            return '';
        },
        color: 'inherit'
      },
      data: [
        {
          value: 70
        }
      ]
    }
  ]
},
    controlName: '等级环形图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    min:0,
    max:100,
    range1:25,
    range2:50,
    range3:75,
    text1:"差",
    text2:"中",
    text3:"良",
    text4:"优",
    legend: true, //图例
    legendTextShow: true,
    legendColor:"#afc0d0",
    legendSize:12,
    color1:"#f95b3b",
    color2:"#ff9c35",
    color3:"#4cec75",
    color4:"#0d88ca",
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 300,
    height: 80,
    name: '横向等级图',
    type: "gradeH",
    locked: false,
    controlId: 37,
    companyId: null,
    controlName: '横向等级图',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    fontSize: 14, //字体大小
    fontColor: "#ffffff", //字体颜色
    bgColor: "transparent",
    color1:"#f95b3b",
    color2:"#ff9c35",
    color3:"#4cec75",
    color4:"#0d88ca",
    opacity: 100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    granularity: null, //时间粒度
    granularityUint: 0, //粒度单位
    timeMerange: null, //指定时段区间
    timeType: 1, //时段类型
    timeNum: 1, //时间
    timeUnit: 1, //时间单位
    period: 1, //近/前
    min:0,
    max:100,
    // gaugeMin:0.2,
    // gaugeMin2:0.1,
    // gaugeMax:0.8,
    // gaugeMax2:0.9,
    legend: true, //图例
    legendColor:"#afc0d0",
    legendSize:12,
    range1:25,
    range2:50,
    range3:75,
    text1:"差",
    text2:"中",
    text3:"良",
    text4:"优",
    // legendTextShow: true,
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
  },
  {
    x: 0,
    y: 0,
    width: 740,
    height: 240,
    name: '列表',
    type: "list",
    locked: false,
    controlId: 29,
    controlName: '列表',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    titleSize:16,
    titleColor:"#d9eaf5",
    bodySize:16,
    bodyColor:"#afc0d0",
    bgColor: "transparent",
    fgColor: "#2a2a2a",
    fontSize:14,
    fontColor:"#afc0d0",
    opacity: 100,
  },
  {
    x: 0,
    y: 0,
    width: 880,
    height: 320,
    name: '抄表',
    type: "table",
    locked: false,
    controlId: 39,
    meterId: null,
    controlName: '抄表',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    titleSize:18,
    titleColor:"#909399",
    titleBgColor:"#ffffff",
    bodySize:16,
    bgColor:"#ffffff",
    bodyColor:"#606266",
    bodyBgColor: "#ffffff",
    opacity: 100,
    meterId:null,
    beginFrame:null,
    endFrame:null,
  },
  {
    x: 0,
    y: 0,
    width: 750,
    height: 705,
    name: '日历',
    type: "calendar",
    locked: false,
    controlId: 36,
    companyId: null,
    controlName: '日历',
    borderWidth: 0,
    borderRadius: 0,
    borderColor: '#ffffff',
    bgColor: "transparent",
    fontSize:14,
    fontColor:'#ffffff',
    opacity:100,
    unit: null, //单位
    rate: 1, //刷新频率
    decimal: null, //小数
    attrList: [{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    },{
      attrKey: null,
      type: 1,
      companyId: null,
      datasetId: null
    }], //数据源
    chartsList: [], // 关联图表
    textList:[],    // 关联标签
  },{
    x: 0,
    y: 0,
    width: 880,
    height: 660,
    name: '设备地图-3d',
    type: "deviceMap-3d",
    locked: false,
    controlId: 40,
    controlName: '设备地图-3d',
    interactiveList:[
      {panelId:null,panelBlock:null},
      {panelId:null,panelBlock:null},
      {panelId:null,panelBlock:null}
    ]
    // borderWidth: 0,
    // borderRadius: 0,
    // borderColor: '#ffffff',
    // titleSize:18,
    // titleColor:"#909399",
    // titleBgColor:"#ffffff",
    // bodySize:16,
    // bgColor:"#ffffff",
    // bodyColor:"#606266",
    // bodyBgColor: "#ffffff",
    // opacity: 100
  }
]

// 管道接头
export const conduitConnector = {
  leftX: [{
      id: 0,
      url: ''
    },
    {
      id: 24,
      url: require('@/../static/indexEditorIcon/24.png')
    },
    {
      id: 27,
      url: require('@/../static/indexEditorIcon/27.png')
    },
    {
      id: 29,
      url: require('@/../static/indexEditorIcon/29.png')
    },
    {
      id: 30,
      url: require('@/../static/indexEditorIcon/30.png')
    },
    {
      id: 31,
      url: require('@/../static/indexEditorIcon/31.png')
    }
  ],
  rightX: [{
      id: 0,
      url: ''
    },
    {
      id: 25,
      url: require('@/../static/indexEditorIcon/25.png')
    },
    {
      id: 26,
      url: require('@/../static/indexEditorIcon/26.png')
    },
    {
      id: 28,
      url: require('@/../static/indexEditorIcon/28.png')
    },
    {
      id: 29,
      url: require('@/../static/indexEditorIcon/29.png')
    },
    {
      id: 31,
      url: require('@/../static/indexEditorIcon/31.png')
    }
  ],
  topY: [{
      id: 0,
      url: ''
    },
    {
      id: 24,
      url: require('@/../static/indexEditorIcon/24.png')
    },
    {
      id: 25,
      url: require('@/../static/indexEditorIcon/25.png')
    },
    {
      id: 28,
      url: require('@/../static/indexEditorIcon/28.png')
    },
    {
      id: 30,
      url: require('@/../static/indexEditorIcon/30.png')
    },
    {
      id: 31,
      url: require('@/../static/indexEditorIcon/31.png')
    }
  ],
  bottomY: [{
      id: 0,
      url: ''
    },
    {
      id: 26,
      url: require('@/../static/indexEditorIcon/26.png')
    },
    {
      id: 27,
      url: require('@/../static/indexEditorIcon/27.png')
    },
    {
      id: 28,
      url: require('@/../static/indexEditorIcon/28.png')
    },
    {
      id: 29,
      url: require('@/../static/indexEditorIcon/29.png')
    },
    {
      id: 30,
      url: require('@/../static/indexEditorIcon/30.png')
    }
  ],
}

// 所有接头
export const ConnectorList = [{
    id: 24,
    url: '24.png'
  },
  {
    id: 25,
    url: '25.png'
  },
  {
    id: 26,
    url: '26.png'
  },
  {
    id: 27,
    url: '27.png'
  },
  {
    id: 28,
    url: '28.png'
  },
  {
    id: 29,
    url: '29.png'
  },
  {
    id: 30,
    url: '30.png'
  },
  {
    id: 31,
    url: '31.png'
  },
]

//管道颜色
export const conduitColorOptions = [{
  id: 1,
  name: '黑色',
  YGif: 'gray_top_gif.gif', //gif
  YPng: 'gray_top_png.png', //png
  XGif: 'gray_gif.gif', //gif
  XPng: 'gray_png.png' //png
}, {
  id: 2,
  name: '红色',
  YGif: 'red_top_gif.gif', //gif
  YPng: 'red_top_png.png', //png
  XGif: 'red_gif.gif', //gif
  XPng: 'red_png.png' //png
}, {
  id: 3,
  name: '蓝色',
  YGif: 'blue_top_gif.gif', //gif
  YPng: 'blue_top_png.png', //png
  XGif: 'blue_gif.gif', //gif
  XPng: 'blue_png.png' //png
}, {
  id: 4,
  name: '绿色',
  YGif: 'green_top_gif.gif', //gif
  YPng: 'green_top_png.png', //png
  XGif: 'green_gif.gif', //gif
  XPng: 'green_png.png' //png
}, {
  id: 5,
  name: '橙色',
  YGif: 'org_top_gif.gif', //gif
  YPng: 'org_top_png.png', //png
  XGif: 'org_gif.gif', //gif
  XPng: 'org_png.png' //png
}]
export const chartsColorOptions = {
  baseColor: ['#0d88ca', '#ff9c35', '#f95b3b', '#3372e8', '#674df6', '#b736d2', '#ed4699', '#fa606f', '#4cec75',
    '#15cdc0'
  ],
  lineColor: [
    ['#086bb7', '#15afe4'],
    ['#ff8813', '#ffb35a'],
    ['#f64725', '#ff8062'],
    ['#2859e4', '#49a2f0'],
    ['#5b41f7', '#846af5'],
    ['#a618ca', '#d265df'],
    ['#ed197d', '#ed6fb3'],
    ['#f74141', '#ff8eb3'],
    ['#19c00d', '#62ffa1'],
    ['#15ba95', '#15dde4'],
  ]
}



// WEBPACK FOOTER //
// ./src/pages/config/control.js